import script from "./BuyInView.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyInView.vue?vue&type=script&setup=true&lang=js"

import "./BuyInView.vue?vue&type=style&index=0&id=2ba6fd33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba6fd33"]])

export default __exports__